import { Component, OnDestroy, OnInit } from '@angular/core';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { Subscription } from 'rxjs';
import { BtnsForGridService } from './btns-for-grid.service';

@Component({
  selector: 'app-btns-for-grid',
  templateUrl: './btns-for-grid.component.html',
  styleUrls: ['./btns-for-grid.component.scss']
})
export class BtnsForGridComponent implements OnInit, OnDestroy {

  subscriptions: Subscription[] = [];
  disabledFilter: boolean;
  disbaledSort: boolean;
  disabledSaveLayout: boolean;

  constructor(
    private btnsForGridService: BtnsForGridService,
    private sweetAlertHelper: SweetAlertHelper
  ) { }

  ngOnInit() {
    this.subsCriptions();
  }

  subsCriptions() {
    this.subscriptions.push(
      this.btnsForGridService.disabledBtn$.subscribe((type) => {
        if (!type) {
          return this.disabledBtn();
        }

        if (type && type.type) {
          const typeAction = {
            'sort': () => this.disbaledSort = type.disabled,
            'filter': () => this.disabledFilter = type.disabled,
            'layout': () => this.disabledSaveLayout = type.disabled
          };
          return typeAction[type.type]();
        }
      })
    );

    this.subscriptions.push(
      this.btnsForGridService.saveLayout$.subscribe((layout) => {
        if (layout) {
          this.btnsForGridService.postSaveLayout(layout).subscribe((res) =>
            this.sweetAlertHelper.createCustomAlert({
              title: 'Success!',
              text: res.message,
              type: 'success'
            }),
            (error) => this.sweetAlertHelper.captureException(error)
          );
        }
      })
    );
  }

  onClearFilter(filter: string) {
    this.btnsForGridService.clearGridFilter(filter);
  }

  onClearSort(filter: string) {
    this.btnsForGridService.clearGridFilter(filter);
  }

  onSaveLayout(layout: string) {
    this.btnsForGridService.clearGridFilter(layout);
  }

  disabledBtn() {
    this.disabledFilter = false;
    this.disbaledSort = false;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/btns-for-grid/btns-for-grid.component.ts